import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { InvoiceTemplate } from "../models/invoice-template.model";
import { AddInvoiceTemplateModel } from "../models/add-invoice-template.model";
import { AddInvoiceTemplateConceptModel } from "../models/add-invoice-template-concept.model";
import { FormGroup } from "@angular/forms";
import { InvoiceTemplateFilter } from "../models/invoice-template.filter.model";

export namespace InvoiceTemplateActions {

  @logDispatcher
  export class GetInvoiceTemplates {
    static readonly type = '[InvoiceTemplate] GetInvoiceTemplates';
    constructor(public user: string, public exerciseId: number, public filter: InvoiceTemplateFilter) {}
  }

  @logDispatcher
  export class GetInvoiceTemplatesSuccess {
    static readonly type = '[InvoiceTemplate] GetInvoiceTemplatesSuccess';
    constructor(public invoiceTemplates: InvoiceTemplate[]) {}
  }

  @logDispatcher
  export class GetInvoiceTemplateDetails {
    static readonly type = '[InvoiceTemplate] GetInvoiceTemplateDetails';
    constructor(public invoiceTemplateId: string) {}
  }

  @logDispatcher
  export class GetInvoiceTemplateDetailsSuccess {
    static readonly type = '[InvoiceTemplate] GetInvoiceTemplateDetailsSuccess';
    constructor(public invoiceTemplate: InvoiceTemplate) {}
  }

  @logDispatcher
  export class AddInvoiceTemplate {
    static readonly type = '[InvoiceTemplate] AddInvoiceTemplate';
    constructor(public user: string) {}
  }

  @logDispatcher
  export class AddInvoiceTemplateSuccess {
    static readonly type = '[InvoiceTemplate] AddInvoiceTemplateSuccess';
    constructor(public addInvoiceTemplate: AddInvoiceTemplateModel, public newInvoiceTemplateId: string) {}
  }

  @logDispatcher
  export class AddInvoiceTemplateConcept {
    static readonly type = '[InvoiceTemplate] AddInvoiceTemplateConcept';
    constructor(public user: string) {}
  }

  @logDispatcher
  export class AddInvoiceTemplateConceptSuccess {
    static readonly type = '[InvoiceTemplate] AddInvoiceTemplateConceptSuccess';
    constructor(public addInvoiceTemplateConcept: AddInvoiceTemplateConceptModel, public newInvoiceTemplateId: string) {}
  }

  @logDispatcher
  export class EditInvoiceTemplate {
    static readonly type = '[InvoiceTemplate] EditInvoiceTemplate';
    constructor(public invoiceTemplateForm: FormGroup, public user: string) {}
  }

  @logDispatcher
  export class EditInvoiceTemplateSuccess {
    static readonly type = '[InvoiceTemplate] EditInvoiceTemplateSuccess';
    constructor(public editInvoiceTemplate: InvoiceTemplate) {}
  }

  @logDispatcher
  export class SetInvoiceTemplatesDefaultState  {
      static readonly type = '[InvoiceTemplate] SetInvoiceTemplatesDefaultState';
      constructor() {}
  }

  @logDispatcher
  export class SetInvoiceTemplateAddFormDefaultState  {
      static readonly type = '[InvoiceTemplate] SetInvoiceTemplateAddFormDefaultState';
      constructor() {}
  }

  @logDispatcher
  export class SetInvoiceTemplateConceptAddFormDefaultState  {
      static readonly type = '[InvoiceTemplate] SetInvoiceTemplateConceptAddFormDefaultState';
      constructor() {}
  }

  @logDispatcher
  export class SetInvoiceTemplateFormDefaultState  {
      static readonly type = '[InvoiceTemplate] SetInvoiceTemplateFormDefaultState';
      constructor() {}
  }

  @logDispatcher
  export class SetInvoiceTemplateFilterDefaultState  {
      static readonly type = '[InvoiceTemplate] SetInvoiceTemplateFilterDefaultState';
      constructor() {}
  }
  @logDispatcher
  export class SetIsListSmaller {
    static readonly type = '[InvoiceTemplate] SetIsListSmaller';
    constructor(public isListSmaller: boolean) {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[InvoiceTemplate] Error';
    constructor(public error: any) {}
  }

  @logDispatcher
  export class SetIsSubmitted {
    static readonly type = '[InvoiceTemplate] SetIsSubmitted';
    constructor(public isSubmitted: boolean) {}
  }

  @logDispatcher
  export class SetIsEdited {
    static readonly type = '[InvoiceTemplate] SetIsEdited';
    constructor(public isEdited: boolean) {}
  }
}
